<template>
  <div id="container"
       class="map"></div>
</template>

<script>
export default {
  props: {
    mapObj: {
      type: Object,
      default () {
        return {
          //查询地址
          selectWords: '北京',
          //查询城市
          selectCity: '北京',
          //地图显示等级
          mapLevel: 10,
        }
      },
    },
  },

  data () {
    return {}
  },
  mounted () {
    let mapLevel = this.mapObj.mapLevel
    //创建地图
    var map = new window.BMap.Map('container')
    // 创建地址解析器实例
    var myGeo = new window.BMap.Geocoder()
    // 将地址解析结果显示在地图上,并调整地图视野
    myGeo.getPoint(
      this.mapObj.selectWords,
      function (point) {
        if (point) {
          map.centerAndZoom(point, mapLevel)
          map.addOverlay(new window.BMap.Marker(point))
        } else {
          alert('您选择地址没有解析到结果!')
        }
      },
      this.mapObj.selectCity
    )
  },
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 100%;
}
</style>